<template>
  <span class="badge" v-b-tooltip.hover :title="relationDescription"> {{ relationDescription }}</span>
</template>

<script>
export default {
  props: ["type", "relatedTask"],
  computed: {
    text() {
      if (this.type == "BLOCKS") {
        return this.$t("task.link.blocks");
      } else if (this.type == "BLOCKED_BY") {
        return this.$t("task.link.blocked-by");
      } else if (this.type == "RELATED") {
        return this.$t("task.link.related");
      } else if (this.type == "SUBTASK") {
        return this.$t("task.link.sub-task");
      } else if (this.type == "PARENT") {
        return this.$t("task.link.parent");
      }
      return this.$t("task.link.related");
    },

    relatedText() {
      if (this.type == "BLOCKS") {
        return this.$t("task.link.badge-blocks");
      } else if (this.type == "BLOCKED_BY") {
        return this.$t("task.link.badge-blocked-by");
      } else if (this.type == "RELATED") {
        return this.$t("task.link.badge-related");
      } else if (this.type == "SUBTASK") {
        return this.$t("task.link.badge-sub-task");
      } else if (this.type == "PARENT") {
        return this.$t("task.link.badge-parent");
      }
      return this.$t("task.link.related");
    },
    relationDescription() {
      if (!this.relatedTask?.no) {
        return this.text;
      }

      // return `#${this.relatedTask.no} ` + this.relatedText;
      return this.relatedText;
    },
  },
};
</script>
<style scoped>
.badge {
  border: 1px solid gray;
  padding: 5px;
  background-color: rgb(255, 255, 255);
  color: gray;
}
</style>
